export default "__VITE_ASSET__B0bjd1DX__"